import type {Agent} from 'api/types';
import type {Schemas} from 'api/dto.generated';
import {transformErrorResponse} from 'store/api';
import {ebsApi} from 'store/ebsApi';
import {mapToPostPutAgentDto} from './mappers/mapAgent';
import {mapAuthority} from './mappers/mapAuthority';

const agentApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getAgentNorafDryRun: build.query<
      Schemas.Authority,
      {agent: Agent},
      Schemas.Authority
    >({
      query: ({agent}) => {
        return {
          url: `agent/${agent.id}/norafdryrun`,
          method: 'POST',
          body: mapToPostPutAgentDto('POST', agent, false),
        };
      },
      transformResponse: mapAuthority,
      transformErrorResponse,
    }),
  }),
});

export const {useLazyGetAgentNorafDryRunQuery} = agentApi;
